import React, { CSSProperties } from "react";
import { XSlidingDiv } from "./XSlidingDiv";

export const XTravelingContent = ({
  children,
  durationInMs,
  style,
}: {
  children: React.ReactNode;
  durationInMs: number;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        pointerEvents: "none",
        ...style,
      }}
    >
      <XSlidingDiv
        durationInMs={durationInMs}
        animated={true}
        style={{
          height: 300,
          background:
            "linear-gradient(rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 0.3) 100%)",
          width: "104vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {children}
      </XSlidingDiv>
    </div>
  );
};
